import { useState, useEffect } from 'react';
import { tagAPI } from '../services/api';
import { Tag } from '../types';
import toast from 'react-hot-toast';

export const useTags = () => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTags = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await tagAPI.getTags();
      setTags(response);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '태그를 불러오는데 실패했습니다.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const fetchPopularTags = async (limit: number = 10) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await tagAPI.getPopularTags(limit);
      setTags(response);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '인기 태그를 불러오는데 실패했습니다.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return {
    tags,
    loading,
    error,
    refetch: fetchTags,
    fetchPopularTags,
  };
};